<template>
	<div class="layer-project" data-project-name="lgchem-history">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section
				class="project-visual"
				data-1x="bg-overview"
				data-2x="bg-overview@2"
			>
				<div>
					<h1 class="project-tit">
						<span class="award18"></span>History of LG Chem
					</h1>
					<a href="http://www.lgchem.com/kr/lg-chem-history" target="_blank"
						>www.lgchem.com/kr/lg-chem-history</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						LG화학의 70년 역사를 담은 역사관 사이트로, LG화학이 세계적인 소재
						기업으로 성장하기까지의 과정을 담고 있습니다.
						<br class="blank pc" />무겁고 딱딱할 수 있는 기업의 역사를 이미지,
						인포그래픽, 영상 등 다양한 방법으로 표현해 LG화학의 역사를 보다 쉽고
						재미있게 이해할 수 있도록 했습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li class="item01">Data</li>
							<li class="item02">Infographic</li>
						</ul>
						<ul class="diagram02">
							<li class="item03">Illustration</li>
							<li class="item04">Movie</li>
						</ul>
						<ul class="diagram03">
							<li class="item05">LG Chem<br />History</li>
						</ul>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<!-- section01 : website -->
			<section class="section section01 full">
				<div class="inner-section">
					<div class="cont-tit-area">
						<strong class="project-subtit max-limit">PC Web</strong>

						<div class="detail-img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec1-cont-tit@m.png"
							/>
						</div>
					</div>
					<div class="detail-cont">
						<!-- website : PC -->
						<div class="content cont01 web-pc-swiper">
							<p class="detail-cont-tit">PC</p>
							<div class="swiper-wrapper">
								<div class="swiper-slide shadow">
									<img
										src="/static/img/project-detail/lgchem-history/sec1-cont01-img01.jpg"
									/>
								</div>
								<div class="swiper-slide shadow">
									<img
										src="/static/img/project-detail/lgchem-history/sec1-cont01-img02.jpg"
									/>
								</div>
							</div>
							<div class="swiper-pagination webpc-indicator"></div>
						</div>
						<!-- website : TABLET -->
						<div class="content cont02 web-tablet">
							<p class="detail-cont-tit">TABLET</p>
							<div class="detail-img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec1-cont02@m.png"
								/>
							</div>
						</div>
						<!-- website : MOBILE -->
						<div class="content cont03">
							<p class="detail-cont-tit">MOBILE</p>
							<div class="web-mb-swiper">
								<div class="swiper-wrapper">
									<div class="swiper-slide shadow">
										<img
											src="/static/img/project-detail/lgchem-history/sec1-cont03-img01.jpg"
										/>
									</div>
									<div class="swiper-slide shadow">
										<img
											src="/static/img/project-detail/lgchem-history/sec1-cont03-img02.jpg"
										/>
									</div>
									<div class="swiper-slide shadow">
										<img
											src="/static/img/project-detail/lgchem-history/sec1-cont03-img03.jpg"
										/>
									</div>
								</div>
								<div class="swiper-pagination webmb-indicator"></div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- section02 : illust images -->
			<section class="section section02 full">
				<div class="inner-section">
					<div class="detail-cont">
						<!-- illust images : free -->
						<ul class="content cont01">
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img01@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img02@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img03@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img04@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img05@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img06@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img07@mt.png"
									data-break="mt-w"
								/>
							</li>
							<li>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lgchem-history/sec2-cont01-img08@mt.png"
									data-break="mt-w"
								/>
							</li>
						</ul>
						<!-- illust images : responsive -->
						<div class="content cont02">
							<div class="cont-img">
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont02.png"
								/>
							</div>
						</div>
						<!-- illust images : circle -->
						<ul class="content cont03">
							<li>
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont03-img01.png"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont03-img02.png"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont03-img03.png"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont03-img04.png"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont03-img05.png"
								/>
							</li>
							<li>
								<img
									src="/static/img/project-detail/lgchem-history/sec2-cont03-img06.png"
								/>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<!-- section03 : MOIVE -->
			<section class="section section03 full">
				<div class="inner-section">
					<p class="detail-cont-tit">MOVIE</p>
					<ul class="detail-cont">
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img01@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img02@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img03@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img04@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img05@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img06@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img07@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img08@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img09@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img10@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img11@m.jpg"
							/>
						</li>
						<li>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec3-cont-img12@m.jpg"
							/>
						</li>
					</ul>
				</div>
			</section>
			<!-- section04 : design concept -->
			<section class="section section04">
				<div class="inner-section">
					<dl class="detail-cont text">
						<dt class="cont-subtit">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec4-cont-txt01@m.png"
							/>
						</dt>
						<dd class="cont-desc">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lgchem-history/sec4-cont-txt02@m.png"
							/>
						</dd>
					</dl>
					<div class="detail-cont color">
						<dl>
							<dt></dt>
							<dd>#000000</dd>
						</dl>
						<dl>
							<dt></dt>
							<dd>#333333</dd>
						</dl>
						<dl>
							<dt></dt>
							<dd>#ca183a</dd>
						</dl>
						<dl>
							<dt></dt>
							<dd>#d37a7a</dd>
						</dl>
						<dl>
							<dt></dt>
							<dd>#7397ae</dd>
						</dl>
						<dl>
							<dt></dt>
							<dd>#9d835c</dd>
						</dl>
					</div>
				</div>
			</section>
			<section class="project-client">
				<strong class="a11y-hidden">LG화학 역사관</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var webpcSwiper;
		var webmobileSwiper;

		var mobileSwiper = function () {
			if (isSlider) {
				isSlider = false;
				webpcSwiper = new Swiper(".web-pc-swiper", {
					spaceBetween: 15,
					pagination: {
						el: ".webpc-indicator",
					},
				});
				webmobileSwiper = new Swiper(".web-mb-swiper", {
					slidesPerView: "auto",
					spaceBetween: 30,
					pagination: {
						el: ".webmb-indicator",
					},
				});
			}
		};

		if (winW < 712) {
			mobileSwiper();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $(this).outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					mobileSwiper();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					webpcSwiper.destroy();
					webmobileSwiper.destroy();
					$(".swiper-pagination").children().remove();
				}
			}
		});
	},
};
</script>

<style scoped>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
/* Common */
div[class^="rwd"] {
	display: none;
}
.layer-project-detail > .pd-none.full {
	padding: 0;
}
.project-subtit {
	line-height: 1.2;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
.section .cont-tit-area {
	word-break: keep-all;
}
.section .detail-cont-tit {
	color: #dadada;
	text-align: center;
	font-weight: 600;
}
.section .detail-img {
	text-align: center;
}
.section p {
	word-break: keep-all;
}
.blank {
	display: none;
}
@media screen and (max-width: 711px) {
	div[class="rwd-mb"] {
		display: inline-block;
	}
	.section.full .max-limit {
		padding-left: 15px;
		padding-right: 15px;
	}
	.section .detail-cont-tit {
		font-size: 70px;
		letter-spacing: -0.25px;
	}
	.blank.mb {
		display: block;
	}
	.shadow-box {
		box-shadow: 12px 14px 16px 0px rgba(0, 0, 0, 0.16);
	}
	.shadow {
		box-shadow: 12px 14px 16px 0px rgba(0, 0, 0, 0.16);
	}
}
@media screen and (min-width: 712px) {
	div[class="rwd-tb"] {
		display: inline-block;
	}
	.section .project-subtit {
		font-size: 2.2rem;
	}
	.section.full .max-limit {
		padding-left: 40px;
		padding-right: 40px;
	}
	.section .detail-cont-tit {
		font-size: 90px;
		letter-spacing: -0.25px;
	}
	.blank.tb {
		display: block;
	}
	.shadow {
		box-shadow: 23px 28px 21px 0px rgba(0, 0, 0, 0.16);
	}
}
@media screen and (min-width: 1280px) {
	div[class="rwd-tb"] {
		display: none;
	}
	div[class="rwd-pc"] {
		display: inline-block;
	}
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.section .project-subtit {
		font-size: 56px;
	}
	.section .detail-cont-tit {
		font-size: 200px;
		letter-spacing: 40px;
		font-weight: 500;
	}
	.blank.tb {
		display: none;
	}
	.blank.pc {
		display: block;
	}
}

/* Project Visual, Project CI */
.project-client {
	background: #e9e9e9 url(/static/img/project-detail/lgchem-history/ci.png) 50% /
		auto 55px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem-history/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem-history/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lgchem-history/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 110px;
	}
}

/* Overview */
.project-overview {
	background-color: #756449;
	color: #fff;
}
.project-overview-diagram {
	display: flex;
	align-items: center;
	text-align: center;
}
.project-overview-diagram ul {
	display: flex;
	justify-content: center;
	align-items: center;
}
.project-overview-diagram li {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
}
.project-overview-diagram ul:not(.diagram03) li {
	position: relative;
	background-color: #fff;
	color: #222;
}
.project-overview-diagram ul li:not(.item04):before {
	position: absolute;
	top: 50%;
	content: "";
	display: block;
	width: 25px;
	height: 1px;
	background-color: #fff;
}
.project-overview-diagram .diagram03 li {
	background-color: #222;
	color: #fff;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram {
		justify-content: space-between;
		flex-direction: column;
		margin: 15px auto 0;
	}
	.project-overview-diagram ul {
		flex-wrap: wrap;
		width: 100%;
	}
	.project-overview-diagram ul:not(.diagram03) li {
		width: 100px;
		height: 100px;
		margin: 15px 0;
	}
	.project-overview-diagram ul:not(.diagram03) li:nth-child(odd) {
		margin-right: 45px;
	}
	.project-overview-diagram ul:not(.diagram03) li:nth-child(even) {
		margin-left: 45px;
	}
	.project-overview-diagram ul:not(.diagram03) li:before {
		right: -60px;
		width: 25px;
		height: 1px;
	}
	.project-overview-diagram ul:not(.diagram03) li:nth-child(even):before {
		display: none;
	}
	.project-overview-diagram .diagram03 li {
		width: 140px;
		height: 140px;
		font-size: 18px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		justify-content: center;
		margin-top: 30px;
	}
	.project-overview-diagram li {
		width: 100px;
		height: 100px;
	}
	.project-overview-diagram ul:not(.diagram03) li {
		margin-right: 35px;
	}
	.project-overview-diagram ul li:not(.item04):before {
		right: -30px;
		width: 25px;
		height: 1px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview-diagram {
		margin: 54px 0 40px;
	}
	.project-overview-diagram li {
		width: 200px;
		height: 200px;
		font-size: 20px;
	}
	.project-overview-diagram ul:not(.diagram03) li {
		margin-right: 63px;
	}
	.project-overview-diagram ul .item04 {
		margin-right: 50px;
	}
	.project-overview-diagram ul li:not(.item04):before {
		right: -50px;
		width: 40px;
		height: 1px;
	}
}

/* section01 */
.layer-project-detail > .section01.full {
	padding: 0;
}
.section01 .cont-tit-area {
	position: relative;
	background-color: #ce0d36;
}
.section01 .project-subtit {
	color: #fff;
}
.section01 .cont-tit-area .detail-img {
	position: absolute;
	right: 0;
	z-index: 10;
}
.section01 .detail-cont {
	background-color: #f3f3f3;
}
.section01 .detail-cont .content {
	position: relative;
}
.section01 .detail-cont .swiper-slide {
	overflow: hidden;
}
@media screen and (max-width: 711px) {
	.section01 .cont-tit-area {
		padding-top: 40px;
		height: 143.75vw;
	}
	.section01 .cont-tit-area .detail-img {
		top: 32.656vw;
		width: 90.625vw;
	}
	.section01 .detail-cont {
		padding-bottom: 40px;
	}
	.section01 .detail-cont .content {
		padding-top: 40px;
	}
	.section01 .detail-cont .content:not(.cont02) {
		padding-bottom: 40px;
	}
	.section01 .detail-cont .swiper-slide {
		width: 100%;
		border-radius: 10px;
	}
	.section01 .cont01 {
		padding-left: 15px;
		padding-right: 15px;
	}
	.section01 .cont02 .swiper-slide {
		display: inline-flex;
		justify-content: center;
		flex-direction: column;
		min-height: 165.8707vw;
		padding-left: 15px;
		padding-right: 15px;
	}
	.section01 .cont03 .detail-cont-tit {
		margin-bottom: 20px;
	}
	.section01 .cont03 .web-mb-swiper {
		width: 48.28vw;
		margin: 0 auto;
	}
}
@media screen and (min-width: 712px) {
	.section01 .cont-tit-area {
		padding-top: 40px;
		height: 42.9577vw;
	}
	.section01 .cont-tit-area .detail-img {
		width: 92.5352vw;
	}
	.section01 .detail-cont {
		padding: 0 40px;
	}
	.section01 .detail-cont .content {
		position: relative;
	}
	.section01 .detail-cont-tit {
		position: absolute;
	}
	.section01 .swiper-wrapper {
		display: flex;
	}
	.section01 .cont01 {
		padding: 110px 0 250px;
	}
	.section01 .cont01 .detail-cont-tit {
		top: calc(50% - 30.2vw);
		left: calc(50% + 9.1549vw);
	}
	.section01 .cont01 .swiper-wrapper {
		align-items: flex-end;
		justify-content: center;
	}
	.section01 .cont01 .swiper-slide {
		width: 41.338vw;
		margin: 0 22px;
		border-radius: 15px;
	}
	.section01 .cont01 .swiper-slide:nth-child(2) {
		transform: translateY(16.4788vw);
	}
	.section01 .cont02 {
		padding-bottom: 8.45vw;
	}
	.section01 .cont02 .detail-cont-tit {
		top: -84px;
		left: calc(50% - 25.5vw);
	}
	.section01 .cont02 .detail-img {
		position: relative;
		z-index: 10;
	}
	.section01 .cont03 .swiper-wrapper {
		align-items: flex-start;
		justify-content: center;
	}
	.section01 .cont03 {
		padding-bottom: 29.6vw;
	}
	.section01 .cont03 .detail-cont-tit {
		top: 0;
		left: calc(50% - 276px);
	}
	.section01 .cont03 .swiper-slide {
		width: 27.183vw;
		margin: 0 12px;
		border-radius: 15px;
	}
	.section01 .cont03 .swiper-slide:nth-child(1) {
		transform: translateY(31.8vw);
	}
	.section01 .cont03 .swiper-slide:nth-child(2) {
		order: 1;
	}
	.section01 .cont03 .swiper-slide:nth-child(3) {
		order: 0;
		transform: translateY(19.8vw);
	}
}
@media screen and (min-width: 1280px) {
	.section01 .cont-tit-area {
		padding-top: 75px;
		height: 610px;
	}
	.section01 .cont-tit-area .detail-img {
		width: auto;
	}
	.section01 .detail-cont {
		padding: 0;
	}
	.section01 .cont01 {
		padding: 340px 0 520px;
	}
	.section01 .cont01 .detail-cont-tit {
		top: calc(50% - 360px);
		left: calc(50% + 100px);
	}
	.section01 .cont01 .swiper-slide {
		width: 587px;
		margin: 0 33px;
		border-radius: 25px;
	}
	.section01 .cont01 .swiper-slide:nth-child(2) {
		transform: translateY(235px);
	}
	.section01 .cont02 {
		padding-bottom: 200px;
	}
	.section01 .cont02 .detail-cont-tit {
		top: -190px;
		left: calc(50% - 466px);
	}
	.section01 .cont03 {
		padding-bottom: 480px;
	}
	.section01 .cont03 .detail-cont-tit {
		top: 35px;
		left: calc(50% - 630px);
	}
	.section01 .cont03 .swiper-slide {
		width: 386px;
		margin: 0 20px;
		border-radius: 25px;
	}
	.section01 .cont03 .swiper-slide:nth-child(1) {
		transform: translateY(575px);
	}
	.section01 .cont03 .swiper-slide:nth-child(3) {
		transform: translateY(360px);
	}
}

/* section02 */
.section02 .cont02 {
	background-color: #373737;
	text-align: center;
}
.section02 .cont03 {
	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;
}
@media screen and (max-width: 711px) {
	.section02 .cont01 {
		padding: 0 15px;
	}
	.section02 .cont01 li {
		width: 100%;
	}
	.section02 .cont01 li:not(.less) {
		margin-top: -10px;
	}
	.section02 .cont01 li:nth-child(odd) {
		text-align: left;
	}
	.section02 .cont01 li:nth-child(even) {
		text-align: right;
	}
	.section02 .cont01 li:nth-child(even):not(.less) {
		margin-top: -15px;
	}
	.section02 .cont01 li img {
		width: 54.073vw;
	}
	.section02 .cont02 {
		padding: 40px 0;
	}
	.section02 .cont02 .cont-img {
		padding: 0 10px;
	}
	.section02 .cont03 {
		flex-wrap: wrap;
		padding-top: 50px;
	}
	.section02 .cont03 li {
		width: 117px;
		margin: 10px;
	}
}
@media screen and (min-width: 712px) {
	.section02 .cont01 {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-wrap: wrap;
	}
	.section02 .cont01 li {
		width: 24.3661vw;
		margin: 18px 30px;
	}
	.section02 .cont02 {
		padding: 40px 0;
	}
	.section02 .cont02 .cont-img {
		width: 77.2535vw;
		margin: 0 auto;
	}
	.section02 .cont03 {
		padding: 55px 0 15px;
	}
	.section02 .cont03 li {
		width: 97px;
		margin: 10px;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .cont01 {
		justify-content: center;
		padding: 0 80px;
	}
	.section02 .cont01 li {
		width: auto;
		margin: 35px 60px;
	}
	.section02 .cont02 {
		padding: 120px 0;
	}
	.section02 .cont02 .cont-img {
		width: auto;
	}
	.section02 .cont03 {
		margin-top: 46px;
		padding: 70px 0;
	}
	.section02 .cont03 li {
		width: 195px;
		margin: 10px;
	}
}
/* section03 */
.layer-project-detail > .section03.full {
	padding: 0;
}
.section03 .detail-cont-tit {
	background-color: #f3f3f3;
}
.section03 .detail-cont {
	display: flex;
	flex-wrap: wrap;
}
@media screen and (max-width: 711px) {
	.section03 .detail-cont-tit {
		padding: 20px;
	}
	.section03 .detail-cont li {
		width: 50%;
	}
}
@media screen and (min-width: 712px) {
	.section03 .detail-cont li {
		width: 33.33%;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .detail-cont-tit {
		padding: 80px;
	}
	.section03 .detail-cont li {
		width: 25%;
	}
}
/* section04 */
.section04 .color {
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-align: center;
}
.section04 .color dl dt {
	border-radius: 50%;
	margin: 0 auto 5px;
}
.section04 .color dl dd {
	font-weight: 400;
	letter-spacing: 0.5px;
}
.section04 .color dl:nth-child(1) dd {
	color: #000000;
}
.section04 .color dl:nth-child(1) dt {
	background-color: #000000;
}
.section04 .color dl:nth-child(2) dd {
	color: #333333;
}
.section04 .color dl:nth-child(2) dt {
	background-color: #333333;
}
.section04 .color dl:nth-child(3) dd {
	color: #ca183a;
}
.section04 .color dl:nth-child(3) dt {
	background-color: #ca183a;
}
.section04 .color dl:nth-child(4) dd {
	color: #d37a7a;
}
.section04 .color dl:nth-child(4) dt {
	background-color: #d37a7a;
}
.section04 .color dl:nth-child(5) dd {
	color: #7397ae;
}
.section04 .color dl:nth-child(5) dt {
	background-color: #7397ae;
}
.section04 .color dl:nth-child(6) dd {
	color: #9d835c;
}
.section04 .color dl:nth-child(6) dt {
	background-color: #9d835c;
}
@media screen and (max-width: 711px) {
	.section04 .text {
		padding: 14px 0;
	}
	.section04 .text dd {
		margin-top: 28px;
	}
	.section04 .text img {
		width: 72.191vw;
	}
	.section04 .color dl {
		margin: 40px 6.683vw 0 4.683vw;
	}
	.section04 .color {
		flex-wrap: wrap;
	}
	.section04 .color dt {
		width: 45px;
		height: 45px;
	}
}
@media screen and (min-width: 712px) {
	.section04 .inner-section {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.section04 .text {
		width: 45.08vw;
		padding: 14px 0;
	}
	.section04 .text dd {
		margin-top: 40px;
	}
	.section04 .text img {
		width: 100%;
	}
	.section04 .color {
		width: 35.6011vw;
	}
	.section04 .color dl {
		margin: 42px 1.756vw;
	}
	.section04 .color {
		flex-wrap: wrap;
	}
	.section04 .color dt {
		width: 45px;
		height: 45px;
	}
}
@media screen and (min-width: 1280px) {
	.section04 .inner-section {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 120px 0;
	}
	.section04 .text {
		width: auto;
	}
	.section04 .text dd {
		margin-top: 80px;
	}
	.section04 .text img {
		width: auto;
	}
	.section04 .color {
		width: 520px;
	}
	.section04 .color dl {
		margin: 35px 40px;
	}
	.section04 .color dl:nth-child(3n) {
		margin-right: 0;
	}
	.section04 .color {
		flex-wrap: wrap;
	}
	.section04 .color dt {
		width: 91px;
		height: 91px;
	}
}
</style>




// WEBPACK FOOTER //
// src/projects/lgchem-history.vue